module.exports = __webpack_public_path__ + "img/W9.a16725cf.png";